<template>
    <v-container grid-list-xs>
        <div>
            <v-row>
                <v-col>
                    <v-sheet class="pa-5" elevation="3">
                        <h4 class="mb-2 primary--text">
                            Please provide your Monthly Net Income to request a new credit limit
                        </h4>
                        <p class="mt-10">
                            <strong>Requested Credit Limit: {{ newCreditLimitCents | currencyWhole }}</strong>
                        </p>
                        <v-row>
                            <v-col lg="8">
                                <Form @submit="submit">
                                    <CurrencyField id="monthlyIncomeCents" v-model="monthlyIncomeCents" label="Monthly Net Income" required />
                                    <p class="income-details">
                                        <small>
                                            *Your “Net Income” includes what you earn or reasonably expect to earn from
                                            employment, investments, retirement, social security benefits and public
                                            assistance. You can also include money that someone else deposits regularly
                                            into your account (individual or joint) and the amount that you have
                                            available to spend from your assets. If you are 21 or over, you may also
                                            include the amount of someone else’s income that is regularly used to pay
                                            your expenses. Alimony, child support or separate maintenance income need
                                            not be included unless relied upon for credit. <b>WI Residents Only:</b> If
                                            this is an individual account, please also include your spouse’s income.
                                        </small>
                                    </p>
                                    <v-row justify="center" class="mt-12">
                                        <v-col>
                                            <BackButton class="mr-4" color="primary" rounded />
                                        </v-col>

                                        <v-col class="text-right">
                                            <SubmitButton
                                                class="secondary"
                                                rounded
                                                :submitting="submitting"
                                                :disabled="!monthlyIncomeCents"
                                            >
                                                {{ $t("action.submit") }}
                                            </SubmitButton>
                                        </v-col>
                                    </v-row>
                                </Form>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import { sessionState } from "@/state"
    import { workflowService } from "@/service"
    import ChangeCreditLimitAction from "@/action/actions/ChangeCreditLimitAction"
    import { mapState } from "vuex"

    export default {
        data() {
            return {
                monthlyIncomeCents: null,
                submitting: false,
            }
        },

        computed: {
            ...mapState("account", {
                creditLimitCents: state => state.data.creditLimitCents || 0,
                newCreditLimitCents: state => state.data.newCreditLimitCents || 0,
            }),
        },

        methods: {
            async submit() {
                this.submitting = true

                try {
                    await workflowService.invoke(
                        new ChangeCreditLimitAction(sessionState.providerKey, {
                            requestedLimitCents: this.newCreditLimitCents,
                            annualIncomeCents: this.monthlyIncomeCents * 12,
                        })
                    )
                } finally {
                    this.submitting = false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .income-details {
        line-height: 1.2;
        position: relative;
        top: -5px;
    }
</style>
